<template>
  <v-btn
    block
    :color="color"
    :disabled="disabled"
    :loading="loading"
    class="text-none text-caption"
    :class="{
      'text-black': darkText,  
      'text-white': !darkText,
      'rounded-pill': shape === 'pill',
      'rounded-lg': shape === 'box',
    }"
    @click.stop="emitClick"
    variant="elevated"
    :flat="flat"
  >
    <slot></slot>
  </v-btn>
</template>
<script setup lang="ts">

interface Props {
  loading?: boolean
  disabled?: boolean
  color?: string
  darkText?: boolean
  shape?: 'box' | 'pill'
  flat?: boolean
}

const {
  loading = false,
  disabled = false,
  color = 'pwt_palatinate_blue',
  darkText = false,
  shape = 'box',
  flat = false
} = defineProps<Props>()

const emit = defineEmits(['click'])

function emitClick() {
  emit('click')
}
</script>
